// Vínculo empregatício do colaborador (CLT, PJ, Estágio...).
// O backend manda o nome como está na Convenia em `vinculo`, e em
// `vinculo_origem` diz se veio de lá ('convenia') ou foi presumido pelo cargo
// ('cargo') — quem exibe precisa deixar a presunção visível, senão vira dado
// cadastral aos olhos de quem lê.

// nomes longos da Convenia -> rótulo curto que cabe numa coluna de tabela
const CURTOS = [
  [/pessoa\s*jur/i, 'PJ'],
  [/aut[oô]nomo/i, 'Autônomo'],
  [/tempo\s*determinado/i, 'Tempo det.'],
  [/aprendiz/i, 'Aprendiz'],
  [/est[aá]gi/i, 'Estágio'],
  [/s[oó]cio/i, 'Sócio'],
  [/clt/i, 'CLT'],
];

export const vinculoCurto = (v) => {
  const s = String(v || '').trim();
  if (!s) return null;
  const achado = CURTOS.find(([re]) => re.test(s));
  return achado ? achado[1] : s;
};

// cores por tipo, para o vínculo ser lido de relance na lista
const CORES = {
  CLT: { bg: '#e6f7ef', cor: '#116b47', borda: '#a8dcc3' },
  PJ: { bg: '#f1e8ff', cor: '#5b21b6', borda: '#d6c2f5' },
  Estágio: { bg: '#e3f6fb', cor: '#0e6e86', borda: '#b3e3ef' },
  Aprendiz: { bg: '#fff5da', cor: '#8a6d00', borda: '#f0dfa8' },
  Sócio: { bg: '#eef2f7', cor: '#00205b', borda: '#d6dee8' },
};
const PADRAO = { bg: '#f2f4f8', cor: '#495057', borda: '#dee2e6' };

export const vinculoEstilo = (curto) => CORES[curto] || PADRAO;
